// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType =
  {
    StatusTypeCreating: 'creating',
    StatusTypeUpdating: 'updating',
    StatusTypeRunning: 'running',
    StatusTypeDeleting: 'deleting',
    StatusTypeDeleted: 'deleted',
    StatusTypeFailed: 'failed',
  } as const;
export type GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType =
  (typeof GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType)[keyof typeof GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType];

export function instanceOfGithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType(
  value: any,
): boolean {
  for (const key in GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType) {
    if (
      Object.prototype.hasOwnProperty.call(
        GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType,
        key,
      )
    ) {
      if (
        GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType[
          key as keyof typeof GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusTypeFromJSON(
  json: any,
): GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType {
  return GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusTypeFromJSONTyped(
    json,
    false,
  );
}

export function GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType {
  return json as GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType;
}

export function GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusTypeToJSON(
  value?: GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType | null,
): any {
  return value as any;
}

export function GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType {
  return value as GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType;
}
